import React from "react";

import "../css/heading.css";

function Heading() {
  return (
    <section class="section top-section">
      <div class="content-container content-theme-dark">
        <div class="content-inner">
          <div class="content-center">
            <h1 className="heading container">Mashup Creator</h1>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Heading;
